export default "__VITE_ASSET__BkDHK_oG__"